// extracted by mini-css-extract-plugin
module.exports = {"title_container":"ThematicsBlocks_title_container__bj8Yz","thematics_container":"ThematicsBlocks_thematics_container__trb1_"};